import { ProductDetailsPrice } from '@/components/blocks/ProductDetails/Price';
import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { Skeleton } from '@mui/material';

interface BundlePriceContentRecommendationProps {
	partNumber: string;
}

export const BundlePriceContentRecommendation: React.FC<BundlePriceContentRecommendationProps> = ({
	partNumber,
}) => {
	const ems = `DPV2BundleProductDetailsPrice_${partNumber}`;
	return (
		<ContentRecommendation
			id={ems}
			properties={{ emsName: ems }}
			withoutFrame
			emptyElement={<ProductDetailsPrice />}
			loadingElement={
				<Skeleton variant="rounded" width="120px" height="20px" sx={{ marginTop: '9px' }} />
			}
		/>
	);
};
